// extracted by mini-css-extract-plugin
export default {"button":"PluginButton__button___tyz9w","tooltip":"PluginButton__tooltip___kSWrz"};